import { API_GET_USER, USER_CHECK_AUTH_SERVICE } from "../constants/User";
import JwtAuthService from "services/JwtAuthService";

export const getApiUser = (user) => {
  return {
    type: API_GET_USER,
    user,
  };
};

export const UserCheckAuthService = (user) => {
  return {
    type: USER_CHECK_AUTH_SERVICE,
    user,
  };
};
